import {
  GET_COMMUNITIES_REQUEST,
  CREATE_COMMUNITY_REQUEST,
  GET_COMMUNITIES_SUCCESS,
  GET_COMMUNITY_BY_ID_SUCCESS,
  GET_COMMUNITY_BY_ID_REQUEST,
  RESET_COMMUNITY_BY_ID_SUCCESS,
  DELETE_COMMUNITY_REQUEST,
  DELETE_COMMUNITY_SUCCESS,
  UPDATE_COMMUNITY_REQUEST,
  UPDATE_COMMUNITY_SUCCESS,
} from '../constants/actionTypes';

export const getCommunitiesRequest = (payload) => ({
  type: GET_COMMUNITIES_REQUEST,
  payload,
});

export const getCommunitiesSuccess = (payload) => ({
  type: GET_COMMUNITIES_SUCCESS,
  payload,
});

export const getCommunityByIdRequest = (payload) => ({
  type: GET_COMMUNITY_BY_ID_REQUEST,
  payload,
});

export const getCommunityByIdSuccess = (payload) => ({
  type: GET_COMMUNITY_BY_ID_SUCCESS,
  payload,
});

export const createCommunityRequest = (payload) => ({
  type: CREATE_COMMUNITY_REQUEST,
  payload,
});
export const resetCommunityByIdSuccess = (payload) => ({
  type: RESET_COMMUNITY_BY_ID_SUCCESS,
  payload,
});

export const deleteCommunityRequest = (payload) => ({
  type: DELETE_COMMUNITY_REQUEST,
  payload,
});

export const deleteCommunitySuccess = (payload) => ({
  type: DELETE_COMMUNITY_SUCCESS,
  payload,
});

export const updateCommunityRequest = (payload) => ({
  type: UPDATE_COMMUNITY_REQUEST,
  payload,
});

export const updateCommunitySuccess = (payload) => ({
  type: UPDATE_COMMUNITY_SUCCESS,
  payload,
});
